import angular from 'angular'

function NominasNominaDocumentosTabulado ($http) {
  this.get = get

  function get (id_proyecto, id_nomina, opciones) {
    return $http.get('/api/nominas/nomina/documentos/tabulado', {
      params: {
        id_proyecto: id_proyecto,
        id_nomina: id_nomina,
        incluir_bancos: opciones.incluir_bancos ? 1 : 0,
        incluir_resumen: opciones.incluir_resumen ? 1 : 0,
        incluir_isr_resumen: opciones.incluir_isr_resumen ? 1 : 0,
        incluir_departamentos: opciones.incluir_departamentos ? 1 : 0,
        omitir_conceptos_cero: opciones.omitir_conceptos_cero ? 1 : 0,
        separar_impuesto_estatal: opciones.separar_impuesto_estatal ? 1 : 0,
        separar_salas: opciones.separar_salas ? 1 : 0,
      },
      download: true,
    })
  }
}

angular.module('nominas.nomina')
  .service('NominasNominaDocumentosTabulado', NominasNominaDocumentosTabulado)



// WEBPACK FOOTER //
// ./src/nominas/nomina/services/Nomina/Documentos/Tabulado.js